import _ from "lodash";

export default {
  data: function() {
    return {
      touchedId: null,
      pageX: 0,
      pageY: 0,
      clientX: 0,
      clientY: 0,
    };
  },
  methods: {
    onTouch: function(ev) {
      this.touchedId = ev.target.id;
      let el = document.getElementById(this.touchedId);

      let cloneEl = el.cloneNode(true);
      cloneEl.id = this.touchedId + "_clone";
      cloneEl.style.display = "none";
      let parentEl = document.getElementById("answersList");
      parentEl.insertBefore(cloneEl, parentEl.lastChild);
    },
    onTouchMove: function(ev) {
      let { pageX, pageY, clientX, clientY } = ev.targetTouches[0];
      let selectedItem = document.getElementById(this.touchedId);
      let cloneEl = document.getElementById(this.touchedId + "_clone");
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
      if (cloneEl.style.position !== "absolute") {
        cloneEl.style.display = "inline";
        cloneEl.style.height = "35px";
        cloneEl.style.position = "absolute";
        cloneEl.style.backgroundColor = "#87CEFA";
        selectedItem.style.backgroundColor = "#cfcfcf"; //grey out selected item
      }

      cloneEl.style.top = pageY + "px";
      cloneEl.style.left = pageX + "px";
      this.pageX = pageX;
      this.pageY = pageY;
      this.clientX = clientX;
      this.clientY = clientY;

      let elements = document.elementsFromPoint(this.clientX, this.clientY);
      let elId = null;
      let point = null;
      _.each(elements, function(e) {
        if (e.id.startsWith("englishAnswer")) {
          elId = e.id;
          point = document.getElementById(elId);
          point.style.backgroundColor = "#57b3ff"; //make background blue on point

          if (localStorage.getItem("point") != elId) {
            if (localStorage.getItem("point")) {
              elId = localStorage.getItem("point");
              point = point = document.getElementById(elId);
              point.style.backgroundColor = "white"; //make background white
              localStorage.removeItem("point");
            } else {
              localStorage.setItem("point", elId);
            }
          }
        }
      });
    },
    onTouchEnd: function(e, item, qIndex) {
      document.body.style.overflow = "auto";
      document.getElementById(this.touchedId + "_clone").remove();
      localStorage.removeItem("point");
      let selectedItem = document.getElementById(this.touchedId);
      selectedItem.style.backgroundColor = "rgba(202, 235, 247, 1)"; //revert back to its original color
      if (!this.clientX && !this.clientY) return;
      let elements = document.elementsFromPoint(this.clientX, this.clientY);
      let elId = null;
      let point = null;

      _.each(elements, function(e) {
        if (e.id.startsWith("englishAnswer")) {
          elId = e.id;
        }
      });

      //reset back to white background
      let questions = document.getElementsByClassName("questions");
      _.each(questions, function(e) {
        if (e.id.startsWith("englishAnswer")) {
          point = document.getElementById(e.id);
          point.style.backgroundColor = "white";
        }
      });

      if (!elId) return;

      let index = elId.substr(elId.length - 1, 9999);
      this.selectMultipleItem(e, item, parseInt(index), parseInt(qIndex), true);

      this.disableUsedAnswers(this.touchedId);
      this.pageX = 0;
      this.pageY = 0;
      this.clientX = 0;
      this.clientY = 0;
    },
  },
};
